<script>
export default {
    name: "PatientQueue",

    data() {

        return {
            search: ``,
            patients: [],
        };
    },

    mounted() {
        this.$root.loading=true;
        Promise.allSettled([ this.fetchQueue(), ]).then(() => {
            this.$root.loading=false;
        }).catch(() => { this.$root.loading=false; });
    },

    methods: {

        fetchQueue() {
            let url = `Radiology/GetPastRadiologyQueue`;
                url += this.search ? `?SearchText=${this.search}` : ``;

            return this.$http.get(url).then(response => {
                    this.patients = response.data;
                }).catch(() => {});
        },
    },
}
</script>
<template>
    <tail-base-layout>
        <template v-slot:content>
            <tail-card>
              <template v-slot:card-header>
                <h5 class="font-medium text-base">Past Radiology Queue</h5>
              </template>
              <template v-slot:card-body>
                  <div class="w-full overflow-auto max-h-screen">
                        <div class="w-full flex flex-wrap">
                            <div class="md:w-1/4 sm:w-1/2 p-tiny">
                                <input type="text" 
                                    @keydown.enter="fetchQueue" v-model.trim="search" 
                                    class="input-sm input-control text-sm" placeholder="Search">
                            </div>
                            <div class="md:w-1/12 sm:w-1/4 p-tiny">
                                <button 
                                    class="btn-sm btn-primary text-xs rounded" 
                                        @click.prevent="fetchQueue">
                                            <i class="fa fa-search"></i> Filter</button>
                            </div>
                        </div>
                        <table class="table">
                            <thead class="bg-blue-500 text-white text-xs">
                                <tr class="flex w-full">
                                    <th class="p-tiny w-1/6">Patient</th>
                                    <th class="p-tiny flex-1">Date</th>
                                    <th class="p-tiny flex-1">Progress</th>
                                    <th class="p-tiny w-1/6">Payment</th>
                                    <th class="p-tiny flex-1">Status</th>
                                    <th class="p-tiny flex-1">Payment Status</th>
                                    <th class="p-tiny flex-1">Residence</th>
                                    <th class="p-tiny flex-1">Action</th>
                                </tr>
                            </thead>
                            <tbody 
                                class="bg-gray-200 text-xs font-medium flex flex-col items-center 
                                    overflow-auto w-full" style="height:65vh;">
                                <tr class="flex w-full hover:bg-gray-300" 
                                    v-for="(pat, idx) in patients" 
                                        :class="pat.isUrgent ? `bg-red-300` : `` " :key="idx">
                                    <td class="p-tiny w-1/6">
                                        <h5 class="text-sm text-gray-900">{{ pat.names }}</h5>
                                        <h5 class="text-xs leading-5 text-gray-700">
                                            MRN: {{ pat.patientId }}</h5>
                                        <h5 class="text-xs leading-5 text-gray-700">
                                            IP: {{ pat.opfileno }}</h5>
                                        <h5 class="text-xs leading-5 text-gray-700">
                                            OP: {{ pat.patientId }}</h5>
                                        <h5 class="text-xs leading-5 text-gray-700">
                                            DOB: {{ pat.dob | dateFormat }}</h5>
                                    </td>
                                    <td class="p-tiny flex-1">{{ pat.date | dateFormat }}</td>
                                    <td class="p-tiny flex-1">{{ pat.progress || `-` }}</td>
                                    <td class="p-tiny w-1/6 break-words">{{ pat.pMode }}</td>
                                    <td class="p-tiny flex-1">{{ pat.patientstatus }}</td>
                                    <td class="p-tiny flex-1">{{ pat.payment }}</td>
                                    <td class="p-tiny flex-1">{{ pat.residence || `-` }}</td>
                                    <td class="p-tiny flex-1">
                                        <router-link class="btn-sm btn-primary text-xs rounded"
                                            :to="{ 
                                                    name: `radiology.record-results.create-past`, 
                                                    params: { 
                                                        patientID: pat.patientId,
                                                    },
                                                }"><i class="fa fa-pen"></i> Results</router-link>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                  </div>
              </template>
            </tail-card>
        </template>
    </tail-base-layout>
</template>
